<div *ngIf="basicInfo; else Loading" class="row mb-3">
  <div class="col-12 mb-2">
    <h4 translate>BASIC_INFO</h4>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input gungTranslate="PARTNER_AGREEMENT" [(ngModel)]="basicInfo.agreementName" [renderStatic]="true"
      [labelBold]="true" extraInputClass="p-0"></lib-gung-text-input>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input gungTranslate="WORK_PERFORMED_DATE" [(ngModel)]="basicInfo.date" [renderStatic]="true"
      [labelBold]="true" extraInputClass="p-0"></lib-gung-text-input>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input gungTranslate="REG_NR_WORKING_ORDER" [(ngModel)]="basicInfo.regNr" [renderStatic]="true"
      [labelBold]="true" extraInputClass="p-0"></lib-gung-text-input>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input gungTranslate="REASON_FOR_WORK" [(ngModel)]="basicInfo.reasons" [renderStatic]="true"
      [labelBold]="true" extraInputClass="p-0"></lib-gung-text-input>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-area-input gungTranslate="WORKING_ORDER_COMMENT" [(ngModel)]="basicInfo.comment" [rowsNumber]="5"
      [renderStatic]="true" [labelBold]="true" extraInputClass="p-0"></lib-gung-text-area-input>
  </div>

  <div *ngIf="basicInfo.workState" class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input gungTranslate="WORK_ORDER_STATE" [(ngModel)]="basicInfo.workState" [renderStatic]="true"
      [labelBold]="true" extraInputClass="p-0"></lib-gung-text-input>
  </div>
</div>

<div *ngIf="workingOrder" class="row mb-3">
  <div class="col-12">
    <h4 translate>TIRES</h4>
  </div>
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>TIRE_ID</th>
          <th translate>TIRE_NAME</th>
          <th translate>SUPPLIER_DELIVERY_NUMBER</th>
          <th translate>POSITION</th>
          <th translate>AXEL</th>
          <th translate>UNIT_PRICE</th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.tires; let index = index">
          <td [attr.data-label]="'TIRE_ID' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'TIRE_NAME' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.name }}</a>
          </td>
          <td [attr.data-label]="'SUPPLIER_DELIVERY_NUMBER' | translate"> {{ row.supplierArticleNumber || '-' }}</td>
          <td [attr.data-label]="'POSITION' | translate">
            {{ row.position }}
          </td>
          <td [attr.data-label]="'AXEL' | translate">
            {{ row.axel }}
          </td>
          <td [attr.data-label]="'UNIT_PRICE' | translate">
            <span *ngIf="row.price.discount && row.price.valueNoDiscount">
              <span class="linethrough">{{ row.price.valueNoDiscount | gungCurrency : row.price.currency :
                'symbol-narrow' : '1.2-2' }}</span>
              <span class="ml-2">(-{{ row.price.discount }}%)</span>
            </span>
            {{ row.price.value | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2' }}
          </td>
        </tr>
        <tr *ngIf="calculatedTotalsTires">
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"><b translate>TOTAL_QUANTITY</b></td>
          <td [attr.data-label]="'TOTAL_QUANTITY' | translate">{{ calculatedTotalsTires.qty }}</td>
          <td class="hide-mobile-table"><b translate>TOTAL_VALUE</b></td>
          <td [attr.data-label]="'TOTAL_VALUE' | translate">
            {{ calculatedTotalsTires.total | gungCurrency : calculatedTotalsTires.currency : 'symbol-narrow' : '1.2-2'
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="workingOrder" class="row mb-3">
  <div class="col-12">
    <h4 translate>SERVICES</h4>
  </div>
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>SERVICE_ID</th>
          <th translate>SERVICE_NAME</th>
          <th translate>QUANTITY</th>
          <th translate>UNIT_PRICE</th>
          <th translate>TOTAL_PRICE</th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.services; let index = index">
          <td [attr.data-label]="'SERVICE_ID' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'SERVICE_NAME' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.name }}</a>
          </td>
          <td [attr.data-label]="'QUANTITY' | translate">
            {{ row.qty }}
          </td>
          <td [attr.data-label]="'UNIT_PRICE' | translate">
            <span *ngIf="row.price.discount && row.price.valueNoDiscount">
              <span class="linethrough">{{ row.price.valueNoDiscount | gungCurrency : row.price.currency :
                'symbol-narrow' : '1.2-2' }}</span>
              <span class="ml-2">(-{{ row.price.discount }}%)</span>
            </span>
            {{ row.price.value | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2' }}
          </td>
          <td [attr.data-label]="'TOTAL_PRICE' | translate">
            {{ row.price.value * row.qty | gungCurrency: row.price.currency:'symbol-narrow':'1.2-2' }}
          </td>
        </tr>
        <tr *ngIf="calculatedTotalsServices">
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"><b translate>TOTAL_QUANTITY</b></td>
          <td [attr.data-label]="'TOTAL_QUANTITY' | translate">{{ calculatedTotalsServices.qty }}</td>
          <td class="hide-mobile-table"><b translate>TOTAL_VALUE</b></td>
          <td [attr.data-label]="'TOTAL_VALUE' | translate">{{ calculatedTotalsServices.total | gungCurrency:
            calculatedTotalsServices.currency:'symbol-narrow':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="workingOrder" class="row mb-3">
  <div class="col-12">
    <h4 translate>EXTRAS</h4>
  </div>
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>ARTICLE_WORKING_ORDER</th>
          <th translate>DESCRIPTION_WORKING_ORDER</th>
          <th translate>GROSS_PRICE_WORKING_ORDER</th>
          <th translate>QUANTITY</th>
          <th translate>NET_PRICE</th>
          <th translate>TOTAL_PRICE</th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.extras; let index = index">
          <td [attr.data-label]="'ARTICLE_WORKING_ORDER' | translate">
            <a>{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'DESCRIPTION_WORKING_ORDER' | translate">
            <a>{{ row.description }}</a>
          </td>
          <td [attr.data-label]="'GROSS_PRICE_WORKING_ORDER' | translate">
            {{ row.extra.grossPrice | gungCurrency: calculatedTotalsExtras.currency:'symbol-narrow':'1.2-2' }}
          </td>
          <td [attr.data-label]="'QUANTITY' | translate">
            {{ row.extra.qty }}
          </td>
          <td [attr.data-label]="'PRICE' | translate">
            {{ row.price | gungCurrency: calculatedTotalsExtras.currency:'symbol-narrow':'1.2-2' }}
          </td>
          <td [attr.data-label]="'TOTAL_PRICE' | translate">
            {{ row.price * row.extra.qty | gungCurrency: row.price.currency:'symbol-narrow':'1.2-2' }}
          </td>
        </tr>
        <tr *ngIf="calculatedTotalsExtras">
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"><b translate>TOTAL_QUANTITY</b></td>
          <td [attr.data-label]="'TOTAL_QUANTITY' | translate">{{ calculatedTotalsExtras.qty }}</td>
          <td class="hide-mobile-table"><b translate>TOTAL_VALUE</b></td>
          <td [attr.data-label]="'TOTAL_VALUE' | translate">{{ calculatedTotalsExtras.total | gungCurrency:
            calculatedTotalsExtras.currency:'symbol-narrow':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="workingOrder" class="row">
  <div class="col-12 col-md-7">
    <lib-gung-text-area-input gungTranslate="WORKING_ORDER_DECISION" [renderStatic]="actionsDisabled || !isAdmin"
      [(ngModel)]="workingOrder.extra.decision" [rowsNumber]="3"></lib-gung-text-area-input>
  </div>
  <div class="col-12 col-md-5 text-md-right">
    <h4 translate>TOTAL_VALUE_WORKING_ORDER</h4>
    <span class="ml-3 font-weight-bold">{{ calculatedTotals.total | gungCurrency:
      calculatedTotals.currency:'symbol-narrow':'1.2-2' }}</span>
  </div>
</div>

<div *ngIf="workingOrder" class=" mt-4">
  <button *ngIf="isAdmin || isSales" class="btn btn-success w-100 mb-2"
    (click)="changeWorkOrderStatus($event, 'APPROVED')" [disabled]="actionsDisabled" translate>
    <i class="fa-regular fa-check mr-2"></i>
    <span translate>APROVE_WORK_ORDER</span>
  </button>
  <button *ngIf="isAdmin || isSales" class="btn btn-danger w-100 mb-2"
    (click)="changeWorkOrderStatus($event, 'DECLINED')" [disabled]="actionsDisabled" translate>
    <i class="fa-regular fa-xmark mr-2"></i>
    <span translate>DECLINE_WORK_ORDER</span>
  </button>
  <button *ngIf="isPartner || isAdmin || isSales" class="btn btn-danger w-100 mb-2"
    (click)="changeWorkOrderStatus($event, 'CANCELLED')" [disabled]="actionsDisabled" translate>
    <i class="fa-regular fa-ban mr-2"></i>
    <span translate>CANCEL_WORK_ORDER</span>
  </button>
  <button *ngIf="(isPartner || isAdmin || isSales) && workingOrder?.workState === 'OPEN'" class="btn btn-danger w-100"
    [routerLink]="['/working-order/' + workingOrder.id]" [disabled]="actionsDisabled" translate>
    <i class="fa-light fa-pen-to-square mr-2"></i>
    <span translate>EDIT_WORK_ORDER</span>
  </button>
</div>

<div *ngIf="error" class="alert alert-danger mt-3">
  {{ error | translate }}
</div>

<ng-template #Loading>
  <div class="d-flex justify-content-center w-100 mb-4">
    <i class="fa fa-spinner fa-spin fa-5x"></i>
  </div>
</ng-template>
